{
    "Profile_Notes.notes": "FR: Notes",
    "Profile_Notes.action": "FR: Action",
    "Profile_Notes.refresh": "FR: Refresh",
    "Profile_Notes.addNew": "FR: Add new",
    "Profile_Notes.by": "FR: by: {name} / {date}",
    "Profile_Notes.addNewNote": "FR: Add new Note",
    "Profile_Notes.enterYourNoteHere": "FR: Enter your note here",
    "Profile_Notes.cancel": "FR: Cancel",
    "Profile_Notes.add": "FR: Add",
    "Profile_Notes.editNote": "FR: Edit Note",
    "Profile_Notes.update": "FR: Update"
}
